var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-checkbox",class:{
    'is-checked': _vm.isChecked,
    'is-top': _vm.isTop,
    'is-padding': _vm.setPadding
  },on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }